import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F010Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A037Checked = Boolean(watch(`${sectionDelimiter}Q001A037`));
  const isQ001A038Checked = Boolean(watch(`${sectionDelimiter}Q001A038`));
  const isQ001A039Checked = Boolean(watch(`${sectionDelimiter}Q001A039`));
  const isQ001A040Checked = Boolean(watch(`${sectionDelimiter}Q001A040`));
  const isQ001A041Checked = Boolean(watch(`${sectionDelimiter}Q001A041`));

  const isQ001A051Checked = Boolean(watch(`${sectionDelimiter}Q001A051`));
  const isQ001A052Checked = Boolean(watch(`${sectionDelimiter}Q001A052`));
  const isQ001A053Checked = Boolean(watch(`${sectionDelimiter}Q001A053`));
  const isQ001A054Checked = Boolean(watch(`${sectionDelimiter}Q001A054`));
  const isQ001A055Checked = Boolean(watch(`${sectionDelimiter}Q001A055`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionId}_${sectionCode}_${sectionSubCode}_Q001`}
          subsectionLabel="Foot"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Foot"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="calcaneus:"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="body"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="ant process"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="tuberosity"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="extra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                label="intra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A009`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A010`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="talus:"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="head"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                label="neck"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
              />
              <ChartRowElement
                label="body"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
              />
              <ChartRowElement
                label="dome"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                label="post process"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
              />
              <ChartRowElement
                label="lat process"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
              />
              <ChartRowElement
                label="extra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A018`}
                type="cross-option"
              />
              <ChartRowElement
                label="intra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A019`}
                type="cross-option"
              />
              <ChartRowElement
                label="avulsion"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
              />
              <ChartRowElement
                label="chip fx"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A021`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A022`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="navicular"
                name={`${sectionDelimiter}Q001A023`}
                type="cross-option"
              />
              <ChartRowElement
                label="cuboid"
                name={`${sectionDelimiter}Q001A024`}
                type="cross-option"
              />
              <ChartRowElement
                label="cuniform:"
                name={`${sectionDelimiter}Q001A025`}
                type="cross-option"
              />
              <ChartRowElement
                label="medial"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A026`}
                type="cross-option"
              />
              <ChartRowElement
                label="middle"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A027`}
                type="cross-option"
              />
              <ChartRowElement
                label="lateral"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A028`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A029`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="metatarsal:"
                name={`${sectionDelimiter}Q001A030`}
                type="cross-option"
              />
              <ChartRowElement
                label="1st"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A031`}
                type="cross-option"
              />
              <ChartRowElement
                label="2nd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A032`}
                type="cross-option"
              />
              <ChartRowElement
                label="3rd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A033`}
                type="cross-option"
              />
              <ChartRowElement
                label="4th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A034`}
                type="cross-option"
              />
              <ChartRowElement
                label="5th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A035`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A036`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A037`}
                type="cross-option"
                isDisabled={
                  isQ001A038Checked ||
                  isQ001A039Checked ||
                  isQ001A040Checked ||
                  isQ001A041Checked
                }
              />
              <ChartRowElement
                label="2"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A038`}
                type="cross-option"
                isDisabled={
                  isQ001A037Checked ||
                  isQ001A039Checked ||
                  isQ001A040Checked ||
                  isQ001A041Checked
                }
              />
              <ChartRowElement
                label="3"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A039`}
                type="cross-option"
                isDisabled={
                  isQ001A037Checked ||
                  isQ001A038Checked ||
                  isQ001A040Checked ||
                  isQ001A041Checked
                }
              />
              <ChartRowElement
                label="4"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A040`}
                type="cross-option"
                isDisabled={
                  isQ001A037Checked ||
                  isQ001A038Checked ||
                  isQ001A039Checked ||
                  isQ001A041Checked
                }
              />
              <ChartRowElement
                label="5"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A041`}
                type="cross-option"
                isDisabled={
                  isQ001A037Checked ||
                  isQ001A038Checked ||
                  isQ001A039Checked ||
                  isQ001A040Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A061`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="toe:"
                name={`${sectionDelimiter}Q001A042`}
                type="cross-option"
              />
              <ChartRowElement
                label="1st"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A043`}
                type="cross-option"
              />
              <ChartRowElement
                label="2nd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A044`}
                type="cross-option"
              />
              <ChartRowElement
                label="3rd"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A045`}
                type="cross-option"
              />
              <ChartRowElement
                label="4th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A034`}
                type="cross-option"
              />
              <ChartRowElement
                label="5th"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A046`}
                type="cross-option"
              />
              <ChartRowElement
                label="prox phalanx"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A047`}
                type="cross-option"
              />
              <ChartRowElement
                label="middle"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A048`}
                type="cross-option"
              />
              <ChartRowElement
                label="distal"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A049`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A050`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A051`}
                type="cross-option"
                isDisabled={
                  isQ001A052Checked ||
                  isQ001A053Checked ||
                  isQ001A054Checked ||
                  isQ001A055Checked
                }
              />
              <ChartRowElement
                label="2"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A052`}
                type="cross-option"
                isDisabled={
                  isQ001A051Checked ||
                  isQ001A053Checked ||
                  isQ001A054Checked ||
                  isQ001A055Checked
                }
              />
              <ChartRowElement
                label="3"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A053`}
                type="cross-option"
                isDisabled={
                  isQ001A051Checked ||
                  isQ001A052Checked ||
                  isQ001A054Checked ||
                  isQ001A055Checked
                }
              />
              <ChartRowElement
                label="4"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A054`}
                type="cross-option"
                isDisabled={
                  isQ001A051Checked ||
                  isQ001A052Checked ||
                  isQ001A053Checked ||
                  isQ001A055Checked
                }
              />
              <ChartRowElement
                label="5"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A055`}
                type="cross-option"
                isDisabled={
                  isQ001A051Checked ||
                  isQ001A052Checked ||
                  isQ001A053Checked ||
                  isQ001A054Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A056`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="nondisplaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A057`}
                type="cross-option"
              />
              <ChartRowElement
                label="displaced"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A058`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A059`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                name={`${sectionDelimiter}Q001A060`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F010Interpretation };
